import { render, staticRenderFns } from "./PainterSuperTalkDetails.vue?vue&type=template&id=c8ec2bde&scoped=true"
import script from "./PainterSuperTalkDetails.vue?vue&type=script&lang=js"
export * from "./PainterSuperTalkDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterSuperTalkDetails.vue?vue&type=style&index=0&id=c8ec2bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ec2bde",
  null
  
)

export default component.exports